import { CREATE_SUCCESS_MESSAGE } from '../..';
import { PropertyType } from '../../../common';

const mapEntities = (entities: PropertyType[]) => entities.map((e) => e.value);

export const mapApiToEntity = (data: PropertyType): PropertyType => {
	return {
		user_id: data.userId,
		success: CREATE_SUCCESS_MESSAGE,
	};
};

export const mapEntityToApi = (data: PropertyType): PropertyType => {
	const apiData: PropertyType = {};

	if (data.image) apiData.profile_image = data.image;
	if (data.username) apiData.name = data.username;
	if (data.password) apiData.password = data.password;
	if (data.email) apiData.email = data.email;
	if (data.activePartners) apiData.partners = mapEntities(data.activePartners);
	if (data.activeLanguage.length) apiData.lang_id = data.activeLanguage[0]?.value;
	if (data.activeDateTime.length) apiData.date_format = data.activeDateTime[0]?.value;
	if (data.activeRoles) apiData.roles = mapEntities(data.activeRoles);
	if (data.activePermissions) apiData.addProperties = data.activePermissions;

	return apiData;
};
